import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormioCustomComponent} from "@formio/angular";
import {$translate, $translateKey} from "../../../../core/services/internationalization/localize.service";

@Component({
  selector: 'sb-portal-search,sb-dynamic-portal-search',
  templateUrl: './portal-search.component.html',
  styleUrls: ['./portal-search.component.scss']
})
export class PortalSearchComponent implements FormioCustomComponent<string> {

  @Input()
  disabled: boolean;

  @Input()
  value: string;

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  sofiClient: any;

  observer: MutationObserver;

  constructor() {
  }

  ngOnInit() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType == 1) {
              const element = (node as Element);
              if (element.classList.contains("sofi__container__mainform")) {
                const input = document.querySelector("#sofi__chat__traditional-knowledge-search");
                if (input) {
                  const msg = $translate("ng.0a00000a72811a1181728242dbb22f81.PortalComponent.Template.placeholder")`Search for anything`;
                  input.setAttribute("placeholder", msg);
                  console.debug(`PortalSearchComponent updating Sofi placeholder text to "${msg}"`);
                }
              }
            }
          });
        }
      });
    });
    const node = document.querySelector("#how_can_we_help");
    if (node) {
      this.observer.observe(node, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["id"]
      });
    }
  }

  ngOnDestroy() {
    this.observer && this.observer.disconnect();
  }

  ngAfterViewInit(): void {
    this.sofiInitialise();
  }

  private sofiInitialise() {
    (window as any).include(["SofiClient"], (SofiClient) => {
      // Register sofi to respond to this form instance instance
      this.sofiClient = SofiClient.registerPortalInstance({
        header: `<label class=\"sb-sofi-search-banner__label\">${$translateKey("ng.component.portal-search.label")}</label>`
      });
    });
  }

}
